import { useState, useEffect } from "react";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { TradeTable, Trade } from "../components/trades/TradeTable";
import { AddEditTradeDialog } from "../components/trades/AddEditTradeDialog";
import { DeleteTradeDialog } from "../components/trades/DeleteTradeDialog";
import { tradeService } from "../services/tradeService";

export default function TradesPage() {
  const [trades, setTrades] = useState<Trade[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Dialog states
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedTrade, setSelectedTrade] = useState<Trade | null>(null);

  const fetchTrades = async () => {
    setIsLoading(true);
    try {
      const response = await tradeService.getAllTrades({ sort: "order" }); // Use backend sort by default
      setTrades(response.trades || []);
    } catch (error) {
      console.error("Failed to fetch trades:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTrades();
  }, []);

  const handleEditClick = (trade: Trade) => {
    setSelectedTrade(trade);
    setIsEditOpen(true);
  };

  const handleDeleteClick = (trade: Trade) => {
    setSelectedTrade(trade);
    setIsDeleteOpen(true);
  };

  const handleToggleStatus = async (trade: Trade) => {
    try {
      await tradeService.toggleTradeActive(trade._id);
      // Refresh list to show updated status
      fetchTrades();
    } catch (error) {
      console.error("Failed to toggle status:", error);
    }
  };

  return (
    <DashboardLayout>
      <TradeTable
        trades={trades}
        description="Organize your content by trade or industry."
        isLoading={isLoading}
        onAddClick={() => {
          setSelectedTrade(null);
          setIsAddOpen(true);
        }}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        onToggleStatus={handleToggleStatus}
      />

      <AddEditTradeDialog
        isOpen={isAddOpen || isEditOpen}
        onClose={() => {
          setIsAddOpen(false);
          setIsEditOpen(false);
          setSelectedTrade(null);
        }}
        onSuccess={fetchTrades}
        trade={selectedTrade}
      />

      <DeleteTradeDialog
        isOpen={isDeleteOpen}
        onClose={() => {
          setIsDeleteOpen(false);
          setSelectedTrade(null);
        }}
        onSuccess={fetchTrades}
        trade={selectedTrade}
      />
    </DashboardLayout>
  );
}
